import { LayoutDashboard, ShieldAlert, BookOpen } from 'lucide-react';
import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { useSidebarContext } from '@/context/SidebarContext';
import { ROUTES, PERMISSIONS } from '@/constants';
import { useAuthContext } from '@/context/AuthContext';
import { filterNavItems } from '@/utils/navAccess';
import { cn } from '@/lib/utils';
import { dashboardSidebarNavLinkClassName } from '@/lib/sidebarNav';
export function Sidebar() {
    const { isOpen, isCollapsed } = useSidebarContext();
    const { user } = useAuthContext();

    const navItems = useMemo(

        () => [
            {
                label: 'Dashboard',
                path: ROUTES.DASHBOARD,
                icon: LayoutDashboard,
                requiredPermissions: [PERMISSIONS.VIEW_TASK],
            },
            {
                label: 'User Manual',
                path: ROUTES.DASHBOARD_HELP,
                icon: BookOpen,
                requiredPermissions: [PERMISSIONS.VIEW_TASK],
            },
            {
                label: 'Audit Logs',
                path: ROUTES.ADMIN_AUDIT_LOGS,
                icon: ShieldAlert,
                requiredPermissions: [PERMISSIONS.VIEW_AUDIT_LOG],
            },
        ],
        [],
    );


    const visibleItems = useMemo(() => filterNavItems(user, navItems), [user, navItems]);

    if (!isOpen) return null;

    return (
        <aside
            className={cn(
                'flex flex-col border-r border-border bg-card transition-all duration-300',
                isCollapsed ? 'w-16' : 'w-64'
            )}
        >
            <div className="flex h-14 items-center justify-center border-b border-border px-4">
                <span className="text-lg font-bold tracking-tight text-foreground">
                    {isCollapsed ? (
                        <span>C<span className="text-primary-700">32</span></span>
                    ) : (
                        <span>COP<span className="text-primary-700">32</span></span>
                    )}
                </span>
            </div>

            <nav className="flex-1 space-y-2 p-3">
                {visibleItems.map(({ requiredPermissions: _rp, requiredRole: _rr, ...item }) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) =>
                            dashboardSidebarNavLinkClassName({
                                isActive,
                                expanded: !isCollapsed,
                            })
                        }
                    >
                        <item.icon className="h-4 w-4 flex-shrink-0" />
                        {!isCollapsed && <span>{item.label}</span>}
                    </NavLink>
                ))}
            </nav>
        </aside>
    );
}

export default Sidebar;
